const formState = [
  {
    relationship: "",
  },
  {
    phone: "",
    email: "",
    marketingConsent: false,
  },
  {
    firstName: "",
    lastName: "",
    dob: "",
  },
  {
    street: "",
    city: "",
    state: "",
    postalCode: "",
  },
  {
    income: "",
  },
  {
    ssn: "",
    consent: false,
  },
  {},
  { livingSituation: "" },
  {
    incomeSourceType: "",
    monthly: "",
    companyName: "",
    jobTitle: "",
    hours: "",
    address: "",
    phone: "",
  },
  {},
  {},
]

export default formState
